import React from 'react';
import ReactPlayer from 'react-player/youtube';
import { Col, Grid, Row, Typography } from 'antd';
import classNames from 'classnames';

import classes from './index.module.less';

const VideoStemcell = () => {
	const { md, xl } = Grid.useBreakpoint();
	return (
		<div className="bg-white">
			<div className={classNames('container pt-1 pb-4 pt-md-2 pb-md-5', classes.information)}>
				<div className={classNames('text-center', classes.videoTitle)}>
					<Typography.Title level={2} className={classes.title}>
						Tonton Video Edukasi <br /> Tentang Stem Cell di Indonesia berikut ini!
					</Typography.Title>
				</div>
				<Row>
					<Col className="d-flex justify-content-center" md={24} xs={24}>
						<ReactPlayer
							className={classes['react-player']}
							url={process.env.STEM_CELL_VIDEO}
							width={xl ? 960 : md ? 720 : 320}
							height={xl ? 540 : md ? 405 : 180}
						/>
					</Col>
				</Row>
			</div>
		</div>
	);
};

export default VideoStemcell;
